import { defaultApi } from '@/api';

export interface BudgetDropdownVisible {
  id: number;
  title: string;
  type: 'big' | 'small';
  roadmap_id: number;
  created_at: string;
  updated_at: string;
}

export async function getBudgetDropdownsVisible({ roadmapId }: { roadmapId: number }) {
  const { data } = await defaultApi.get<{
    success: boolean;
    data: BudgetDropdownVisible[];
  }>(`/budget-dropdown-visible/roadmap/${roadmapId}`);
  return data.data;
}

export async function createBudgetDropdownVisible({
  roadmapId,
  newDropdownVisible,
}: {
  roadmapId: number;
  newDropdownVisible: { title: string; type: 'big' | 'small' };
}) {
  const { data } = await defaultApi.post<{
    success: boolean;
    data: BudgetDropdownVisible;
  }>(`/budget-dropdown-visible/${roadmapId}`, newDropdownVisible);
  return data.data;
}

export async function deleteBudgetDropdownVisible({ fieldId }: { fieldId: number }) {
  const { data } = await defaultApi.delete<{
    success: boolean;
    message: string;
  }>(`/budget-dropdown-visible/${fieldId}`);
  return data;
}